/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriggerResponseDto } from './TriggerResponseDto';
import {
    TriggerResponseDtoFromJSON,
    TriggerResponseDtoFromJSONTyped,
    TriggerResponseDtoToJSON,
    TriggerResponseDtoToJSONTyped,
} from './TriggerResponseDto';

/**
 * 
 * @export
 * @interface ListTriggersResponseDto
 */
export interface ListTriggersResponseDto {
    /**
     * 
     * @type {Array<TriggerResponseDto>}
     * @memberof ListTriggersResponseDto
     */
    data: Array<TriggerResponseDto>;
}

/**
 * Check if a given object implements the ListTriggersResponseDto interface.
 */
export function instanceOfListTriggersResponseDto(value: object): value is ListTriggersResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListTriggersResponseDtoFromJSON(json: any): ListTriggersResponseDto {
    return ListTriggersResponseDtoFromJSONTyped(json, false);
}

export function ListTriggersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTriggersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TriggerResponseDtoFromJSON)),
    };
}

export function ListTriggersResponseDtoToJSON(json: any): ListTriggersResponseDto {
    return ListTriggersResponseDtoToJSONTyped(json, false);
}

export function ListTriggersResponseDtoToJSONTyped(value?: ListTriggersResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TriggerResponseDtoToJSON)),
    };
}

